import React, { useState, useEffect } from 'react';
import { aboutAPI } from '../../services/api';
import toast, { Toaster } from 'react-hot-toast';
import { Link } from 'react-router-dom';

const AboutManager = () => {
    const [formData, setFormData] = useState({ title: '', content: '' });
    const [imageFile, setImageFile] = useState(null);
    const [currentImage, setCurrentImage] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        aboutAPI.get().then(res => {
            if (res.data) {
                setFormData({ title: res.data.title || '', content: res.data.content || '' });
                setCurrentImage(res.data.imageUrl || '');
            }
        });
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const data = new FormData();
        data.append('title', formData.title);
        data.append('content', formData.content);
        if (imageFile) data.append('image', imageFile);

        // client-side validation
        const validate = () => {
            if (!formData.title || formData.title.trim().length < 2) return 'Title is required (min 2 chars)';
            if (!formData.content || formData.content.trim().length < 10) return 'Content is required (min 10 chars)';
            if (imageFile) {
                if (!imageFile.type.startsWith('image/')) return 'Uploaded file must be an image';
                if (imageFile.size > 5 * 1024 * 1024) return 'Image must be smaller than 5MB';
            }
            return null;
        };

        const validationError = validate();
        if (validationError) {
            toast.error(validationError);
            setLoading(false);
            return;
        }

        try {
            await aboutAPI.update(data);
            toast.success('About section updated successfully');
        } catch (error) {
            toast.error('Failed to update about section');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-6">
            <Toaster />
            <h1 className="text-3xl font-bold mb-6">About Section Management</h1>
            <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md space-y-4 max-w-2xl mx-auto">
                <input type="text" placeholder="Title" value={formData.title} onChange={(e) => setFormData({ ...formData, title: e.target.value })} className="w-full p-2 border rounded"/>
                <textarea placeholder="Content" value={formData.content} onChange={(e) => setFormData({ ...formData, content: e.target.value })} rows="10" className="w-full p-2 border rounded"/>
                {currentImage && <img src={`${process.env.REACT_APP_API_URL}${currentImage}`} alt="Current" className="max-w-xs rounded"/>}
                <input type="file" onChange={(e) => setImageFile(e.target.files[0])} className="w-full"/>
                <button type="submit" disabled={loading} className="px-4 py-2 bg-green-600 text-white rounded disabled:bg-gray-400">{loading ? 'Updating...' : 'Update About Section'}</button>
            </form>
        </div>
    );
};
export default AboutManager;